import {ContentSetListResultVo} from '../../common/shared/api/nicolas/vo/ContentSetListResultVo.interface';
import {ContentSetList} from '../generated/types';
import {createNormalListViewItem} from './NormalListViewItem';

export function createContentSetList(
  result: ContentSetListResultVo
): ContentSetList {
  return {
    setList: result.set_list.map(set =>
      createNormalListViewItem({}, {contentSetDto: set})
    ),
  };
}
